













































































import { Mixins } from 'vue-mixin-decorator'
import { Component } from 'vue-property-decorator'

import SpaErrorDialog from '@/components/organisms/dialog/ErrorDialog.vue'
import { SubscriptionPaymentHistory as PaymentItemDto, SubscriptionPaymentHistoryService } from '@/services/api/subscription-payment-history'
import { DateFormat, formatPrice } from '@/util/format'
import LoadingMixin, { Status } from '@spa/mixins/loading'

@Component({
  components: {
    SpaErrorDialog,
  },
})
export default class SubscriptionPaymentHistory extends Mixins<LoadingMixin>(LoadingMixin) {

  status: Status = Status.Pending
  subscriptionPaymentHistoryList: PaymentItem[] =  []
  modalConfig: ModalConfig = { show: false }

  readonly formatDate = DateFormat.yyyyMmDd
  readonly formatPrice = formatPrice
  readonly subscriptionPaymentHistoryService = new SubscriptionPaymentHistoryService()

  async created() {
    this.status = Status.Loading
    const result = await this.subscriptionPaymentHistoryService.list()

    result.fold(
      (_error) => {
        this.status = Status.Failed
        this.showErrorModal()
      },
      (list) => {
        this.subscriptionPaymentHistoryList = list.data
        this.status = Status.Completed
      }
    )
  }

  showErrorModal() {
    this.modalConfig = {
      show: true,
      message: 'お支払い履歴が取得できませんでした。<br/>※改善されない場合、お問い合わせよりカスタマーセンターまでお問い合わせください。',
    }
  }

  get isLoading(): boolean {
    return this.status === Status.Loading
  }
}

/**
 * serverのBFF的なAPIレスポンスに由来する型を、実質的にそのまま参照している。
 * このページ独自の関心を反映した型が必要な場合は、改めて独自に定義すること。
 */
type PaymentItem = PaymentItemDto

type ModalConfig = {
  show: true
  message: string
} | { show: false}
